import { IRoles } from "src/permissions/types/IRoles";

export const JOB_ACTION_PERMISSIONS = {
  SEE_JOBS: [IRoles.Business, IRoles.Admin, IRoles.Employee, IRoles.Other],
  CREATE_JOBS_WITHOUT_QUOTE: [IRoles.Business, IRoles.Admin, IRoles.Other],
  CREATE_JOBS: [IRoles.Business, IRoles.Admin, IRoles.Other],
  SEE_CALENDARS_JOBS: [IRoles.Business, IRoles.Admin, IRoles.Employee, IRoles.Other],
  SEE_JOBS_CALENDAR: [IRoles.Business, IRoles.Admin, IRoles.Employee, IRoles.Other],
};
